// Shared configuration for the Phidgets RTD (TMP1200) device.
//
// The string keys below intentionally match the `phidget22.RTDType` and
// `phidget22.RTDWireSetup` enum member names exactly, so the device code can
// resolve them directly (e.g. `phidget22.RTDType[key]`). Keeping these as
// plain values (no phidget22 import) lets the persisted state and settings UI
// reference them without pulling in the phidget22 runtime bundle.

export const RTD_TYPE_OPTIONS = [
  { value: 'PT100_3850', label: 'PT100 (3850 ppm)' },
  { value: 'PT1000_3850', label: 'PT1000 (3850 ppm)' },
  { value: 'PT100_3920', label: 'PT100 (3920 ppm)' },
  { value: 'PT1000_3920', label: 'PT1000 (3920 ppm)' }
] as const;

export type RTDTypeKey = (typeof RTD_TYPE_OPTIONS)[number]['value'];

export const RTD_WIRE_SETUP_OPTIONS = [
  { value: 'WIRES_2', label: '2-wire' },
  { value: 'WIRES_3', label: '3-wire' },
  { value: 'WIRES_4', label: '4-wire' }
] as const;

export type RTDWireSetupKey = (typeof RTD_WIRE_SETUP_OPTIONS)[number]['value'];

// TMP1200 defaults: PT1000 sensor with a 3850ppm curve and a 4-wire setup.
export const DEFAULT_RTD_TYPE: RTDTypeKey = 'PT1000_3850';
export const DEFAULT_RTD_WIRE_SETUP: RTDWireSetupKey = 'WIRES_4';

export interface PhidgetsRTDSettings {
  rtdType: RTDTypeKey;
  rtdWireSetup: RTDWireSetupKey;
}

export const getRTDTypeLabel = (value: RTDTypeKey): string =>
  RTD_TYPE_OPTIONS.find((o) => o.value === value)?.label ?? value;

export const getRTDWireSetupLabel = (value: RTDWireSetupKey): string =>
  RTD_WIRE_SETUP_OPTIONS.find((o) => o.value === value)?.label ?? value;
